// Module
var code = `<div appHeaderBar>
    <header-bar-title>Sign Up</header-bar-title>
</div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <app-cobrand-header [property]="property.nickname"
                        [manager]="property.hoa.pmc.name"
                        [association]="property.hoa.name"
                        [headerMessage]="'Register for'">
    </app-cobrand-header>
    <form name="RegistrationForm" id="RegistrationForm" #registrationForm="ngForm" (submit)="submit()">
        <div class="HOA-misc-guidedSteps__container" >
            <div class="HOA-container__header">
                <h1 class="HOA-container__header-text">
                    Registration Information
                </h1>
                <app-pmc-logo class="u-right" [property]="property" *ngIf="property"></app-pmc-logo>
            </div>
            <div class="HOA-container__content">
                <app-personal-info-easy
                        [personalInfoData]="personalInfoData"
                        (invalidCheck)="emailAddressValid(\$event)">
                </app-personal-info-easy>
                <app-property-info-easy
                        [homeowner]="homeowner"
                        [property]="property"
                        [registrationType]="'easy'">
                </app-property-info-easy>
            </div>
        </div>
        <div class="HOA-misc-guidedSteps__container">
            <div class="HOA-container__header">
                <h1 class="HOA-container__header-text">
                    Create {{emailAddressExists && !isHoaHomeowner ? 'Account' : 'Password'}}
                </h1>
            </div>
            <div class="HOA-container__content">
                <app-password
                        *ngIf="!emailAddressExists || isHoaHomeowner"
                        [homeowner]="homeowner"
                        [userPassword]="password"
                        (passwordValidation)="onPasswordValidation(\$event)">
                </app-password>
                <div class="HOA-container__content--borderNone
                                    HOA-flex-component HOA-flex-component-sm-col-lg-row">
                    <div class="HOA-flextable-component__form--left">
                        <input type="checkbox"
                               id="viewedTc"
                               name="viewedTc"
                               tid="viewedTc"
                               style="margin-bottom: 26px;
                                            accent-color: #00505c;
                                            height: 15px"
                               [(ngModel)]="viewedTc"
                               [ngClass]="{'is-invalid': false}">
                        <label for="optIn" class="HOA-font-light">Yes, I agree to the </label>
                        <a (click)="showTc()">Terms and Conditions</a>.
                    </div>
                </div>
                <div class="HOA-container__content--borderNone
                                HOA-flex-component HOA-flex-component-sm-col-lg-row">
                    <div class="HOA-flextable-component__form-vertical
                                    HOA-flextable-component__cell--alt50
                                    HOA-flextable-component__form--left" style="flex-direction: row">
                        <input type="checkbox"
                               id="optIn"
                               name="optIn"
                               tid="optIn"
                               class="Field u-cf"
                               style="margin-bottom: 26px;
                                            accent-color: #00505c;
                                            height: 15px"
                               [(ngModel)]="optIn"
                               [ngClass]="{'is-invalid': false}">
                        <label for="optIn" class="HOA-font-light">
                            Yes. I’d like to stay in touch with First Citizens Bank and agree to receive periodic email updates and offers. I understand I can unsubscribe at any time.
                        </label>
                    </div>
                </div>
                <div class="HOA-container__content HOA-container__content--borderNone">
                    <div class="HOA-Checking-Detail-button-container">
                        <button name="cancel"
                                id="cancel"
                                tid="cancel"
                                type="button"
                                class="Button Button--link"
                                (click)="cancel()">
                            Cancel
                        </button>
                        <button name="submit"
                                id="submit"
                                tid="submit"
                                type="submit"
                                class="Button Button--blue"
                                [disabled]="registrationForm.invalid || invalid()">
                            Create Account
                        </button>
                    </div>
                    <div class="u-pT2 HOA-flex-component HOA-font-fine-print">
                        <span class="asterisk-required">&#42;</span>
                        &nbsp;Indicates required field</div>
                </div>
            </div>
        </div>
    </form>
</app-page-content>`;
// Exports
module.exports = code;